<template>
    <div class="relative flex flex-col gap-2">
        <label v-if="label">{{ label }}</label>
        <InputText v-model="modelValue"
                   :placeholder="placeholder"
                   :disabled="disabled"
                   :size="size"
        />
    </div>
</template>
<script setup lang="ts">
    import InputText from 'primevue/inputtext';

    // Refs
    const modelValue = defineModel<any>();

    // Props
    withDefaults(defineProps<{
        label: string,
        placeholder?: '' | string,
        disabled?: boolean,
        size?: 'small' | 'large'
    }>(), {
        size: 'small'
    });
</script>